import React from "react";

import RichText from "@/components/atoms/rich-text/rich-text";
import withBrand from "@/components/with-brand";

import Styles from "./cover-details-drawer-content.module.css";

type CoverDetailsDrawerContentCardProps = {
  benefitCopy: string;
  subTitle: string;
  title: string;
  brand?: "staysure" | "avanti";
};

function CoverDetailsDrawerContent({
  benefitCopy,
  subTitle,
  title,
  brand = "staysure",
}: Readonly<CoverDetailsDrawerContentCardProps>) {
  return (
    <div className="mt-[12px] p-spacing-m sm:w-[248px] md:w-[264px] lg:w-[392px] bg-surface-neutral-option-2 rounded-radius-lg">
      <div
        className={`"sm:w-[216px] md:w-[232px] lg:w-[360px] font-semibold-font pb-spacing-xs font-semibold sm:text-[23px] md:text-[25px] sm:leading-[26px] md:leading-[29px] text-text-title coverDetailsDrawerContent-testid ${brand} ${Styles.coverDetailsDrawerContentTitle}`}
        data-testid="coverDetailsDrawerContent-testid"
      >
        {title}
      </div>
      <div className="min-w-[80px] font-semibold-font pb-spacing-xs font-bold text-text-functional text-xs leading-[27px]">
        {subTitle}
      </div>
      <div className="font-normal text-xs leading-[27px] font-semibold-font sm:w-[216px] md:w-[232px] lg:w-[360px] text-text-body">
        <RichText richText={benefitCopy} />
      </div>
    </div>
  );
}

export default withBrand(CoverDetailsDrawerContent);
